import React, { useEffect, useState } from 'react'
import { CardHeader, EncuestaLoading, InfoCard, NameLabel, ThanksMessage, checkEncuesta, onFinishFailed } from '../utils'
import { Form, Input, Button, message, Radio } from 'antd'
import { sendDataBody } from '../../resources'
import { ows_catalog } from './ows.catalog'
export default function OwsEncuesta({ idpaciente, idmedico, token, visita, session, protocolo = 'default' }) {

    const [encuestaNotExists, setEncuestaNotExists] = useState(null)
    const [checking, setChecking] = useState(true)
    const [pacienteData, setPacienteData] = useState({})
    const [medicoData, setMedicoData] = useState({})

    useEffect(() => {
        init()
    }, [])

    function init() {
        checkEncuesta(idpaciente, visita, 'ows', session, protocolo, setPacienteData, idmedico, setMedicoData, setEncuestaNotExists, setChecking)

    }

    const onFinish = (values) => {
        console.log('Orginal values: ', values)
        const body = {
            usuario: idpaciente,
            medico: idmedico,
            ows: Object.values(values),
            tipo: 'ows',
            uuid: token,
            visita,
            sesion: session,
            protocolo
        }
        console.log('Body:', body);
        sendDataBody('encuestas/add', body).then((rs) => {
            console.log('add enc resp', rs)
            message.success(rs.message)
        }).then(() => init())
    };

    const onChange = (e) => {
        console.log('radio checked', e.target.value);
    };

    if (checking) return <EncuestaLoading />

    if (!encuestaNotExists) return <ThanksMessage />

    return (
        <div className='parentContainer'>
            <CardHeader title="Encuesta OWS">
                <NameLabel pacienteData={pacienteData} />

                <NameLabel pacienteData={medicoData} label="Médico: " />

                <InfoCard label="Sesión" value={session} />
            </CardHeader>
            <div className='formContainer'>
                <h5>Escala de abstinencia de opiáceos (Opiate Withdrawal Scale, OWS)</h5>
                <br />
                <h6>Seleccione el nivel de presencia de los siguientes sintomas/signos</h6>
                <br />

                <Form
                    layout='vertical'
                    name="ows_enc"
                    // labelCol={{ span: 24 }}
                    // wrapperCol={{ span: 24 }}
                    initialValues={[]}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >

                    {
                        ows_catalog.map((q, i) => <Form.Item
                            label={q}
                            name={i}
                            rules={[
                                {
                                    required: true,
                                    message: 'Seleccione una respuesta',
                                },
                            ]}
                        >
                            <Radio.Group onChange={onChange} >
                                <Radio value={0}>Ausente</Radio>
                                <Radio value={1}>Leve</Radio>
                                <Radio value={2}>Moderado</Radio>
                                <Radio value={3}>Severo</Radio>
                            </Radio.Group>
                        </Form.Item>)
                    }

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button form='ows_enc' type="primary" htmlType="submit">
                            Enviar respuestas
                        </Button>
                    </Form.Item>
                </Form>

            </div>
        </div>
    )
}